export default (siteName) => [
    {
        path: 'staff',
        name: 'staff',
        component: () => import('../../components/dashboard/Settings/UserSetting/index'),
        meta: {
            title: `帳號管理${siteName}`,
            activeMenu: 'admin',
        },
    },
    {
        path: 'staff/add/',
        name: 'staff-add',
        component: () => import('../../components/dashboard/Settings/UserSetting/UserEditPage'),
        meta: {
            title: `帳號管理-新增${siteName}`,
            activeMenu: 'admin',
        },
    },
    {
        path: 'staff/:sno/edit/',
        name: 'staff-edit',
        component: () => import('../../components/dashboard/Settings/UserSetting/UserEditPage'),
        meta: {
            title: `帳號管理-編輯${siteName}`,
            activeMenu: 'admin',
        },
    },
];
